module.exports = __webpack_public_path__ + "img/自定义主办单位.e0cdf326.png";